
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

export const NOTIFICATION = loadTypes('NOTIFICATION')
export const NOTIFICATION_SETUP = loadTypes('NOTIFICATION_SETUP')
export const NOTIFICATION_NUMBER = loadTypes('NOTIFICATION_NUMBER')
export const NOTIFICATION_MARK = loadTypes('NOTIFICATION_MARK')
export const NOTIFICATION_PER_PAGE = 10

const initialState = {
  data: [],
  data_setup: [],
  isFetchingSetup: false,
  isFetching: false,
  total: null,
  currentPage: 1
}

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION_MARK.REQUEST:
      return {
        ...state,
        isFetchingSetup: true,
        isFetching: true
      }
    case NOTIFICATION_SETUP.REQUEST:
      return {
        ...state,
        isFetchingSetup: true,
        isFetching: true
      }
    case NOTIFICATION.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case NOTIFICATION.SUCCESS:
      return {
        ...state,
        isFetching: false,
        total: action.response.total,
        currentPage: action.response.page,
        data: action.response.data
      }
    case NOTIFICATION_SETUP.SUCCESS:
      return {
        ...state,
        isFetchingSetup: false,
        data_setup: action.response
      }
    case NOTIFICATION_MARK.SUCCESS:
      const res_id = action.response._id ?? ''
      let data_nof = state.data
      data_nof.forEach(function(item, index) {
        item.suggestions = item.suggestions.filter(suggestion =>
          suggestion._id !== res_id)
      })
      return {
        ...state,
        isFetching: false,
        isFetchingSetup: false,
        data: data_nof.filter(item => item.suggestions.length != 0),
        data_setup: state.data_setup.filter(item => item._id !== res_id),
        total: state.total - 1
      }
    case NOTIFICATION_NUMBER.SUCCESS:
      return {
        ...state,
        total: action.response.total
      }

    case NOTIFICATION.FAILURE:
    case NOTIFICATION_SETUP.FAILURE:
    case NOTIFICATION_MARK.FAILURE:
      return {
        ...state,
        isFetchingSetup: false,
        isFetching: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/notifications/index.js